import React from 'react'
import ExternalCalendarListComponent from '../common/ExternalCalendarListComponent'

export default function ExternalCalendarsModal() {
    return (<div className='p-2' style={{overflow: 'auto',height: '100%'}}>
        <ExternalCalendarListComponent hideInactive={true} />
    </div>
    )
}
